"use client";

import config from "@/app.config";
import Heading from "@/components/heading";
import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import Image from "next/image";

export default function DroneRepair() {
  return (
    <div className="py-6 md:py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="max-w-2xl mx-auto mb-6 md:mb-10">
          <Heading>Professional Drone Repair by EVERSE</Heading>
        </div>
        <p className="text-base md:text-2xl mb-4">
          EVERSE provides fast, reliable drone repair services across India for
          DJI Mini, Air, Mavic, and Enterprise drones. Our expert technicians
          use genuine parts, follow a transparent repair process, and ensure
          every drone is tested and calibrated before delivery.
        </p>
        <div className="mb-6">
          <div className="bg-blue-200 font-semibold inline-block px-3 py-1 rounded-lg mb-4">
            We Fix
          </div>
          <div className="bg-linear-to-r from-primary to-secondary rounded-xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {[
              "Gimbal & camera issues",
              "Sensor errors",
              "GPS issues",
              "Battery problems",
              "Motor faults",
              "Firmware errors",
            ].map((v, i) => (
              <div
                className="p-4 flex items-center gap-4 text-white text-base md:text-lg"
                key={i}
              >
                <CheckIcon />
                <span>{v}</span>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="bg-blue-200 font-semibold inline-block px-3 py-1 rounded-lg mb-4">
            Why EVERSE?
          </div>
          <div className="max-w-5xl mx-auto mb-8">
            <div className="flex md:justify-center gap-y-4 gap-x-8 items-center flex-wrap">
              {[
                {
                  title: "Expert Technicians",
                  image: "/images/home/Tool.png",
                },
                {
                  title: "Quality Testing Before Delivery",
                  image: "/images/home/Box.png",
                },
                {
                  title: "Genuine Spare Parts",
                  image: "/images/home/Settings.png",
                },
                {
                  title: "Fast Turnaround Time",
                  image: "/images/home/Fast forward.png",
                },
                {
                  title: "Transparent Pricing",
                  image: "/images/home/Dollar sign.png",
                },
              ].map((v, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 rounded-lg hover:shadow-md transition-all px-4 py-2.5 hover:bg-white"
                >
                  <Image
                    src={v.image}
                    alt="Image"
                    width={48}
                    height={48}
                    className="shrink-0 size-10"
                  />
                  <span className="text-base md:text-lg whitespace-nowrap">
                    {v.title}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <div className="rounded-lg px-8 py-3 bg-[#e6f2d7] font-semibold text-center">
              Get your drone back in the air fast and safely.
            </div>
          </div>
          <div className="flex justify-center mt-6">
            <Button
              variant="contained"
              size="large"
              href={`https://wa.me/+91${config.contact.whatsappNumber}`}
              target="_blank"
            >
              Get Your Drone Repaired
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
